import { render, staticRenderFns } from "./c_settings.vue?vue&type=template&id=795aad94&"
import script from "./c_settings.vue?vue&type=script&lang=js&"
export * from "./c_settings.vue?vue&type=script&lang=js&"
import style0 from "./c_settings.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports